export class NoShortIdError extends Error {
  constructor(originalPath: string) {
    super(`Tried generate path '${originalPath}' without shortId`)
    this.name = 'NoShortIdError'
  }
}
